import { Box, Typography, Button, Stack } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { labels } from 'common/global/constants';

const SharedWithErrorState = ({ height = 260, onRetry }) => {
  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='center'
      height={height}
      sx={(theme) => ({
        borderRadius: '8px',
        backgroundColor: theme.palette.box.white,
        border: '1px dashed grey',
        marginRight: '14px',
      })}
    >
      <Stack spacing={1.5} alignItems='center'>
        <Typography
          sx={(theme) => ({
            fontSize: '14px',
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.text.primary,
          })}
        >
          {labels.sharedRecipientsErrorTxt}
        </Typography>

        <Button
          variant='outlined'
          size='small'
          data-testid={'retry-btn'}
          startIcon={<RefreshIcon />}
          onClick={onRetry}
          sx={(theme) => ({
            backgroundColor: theme.palette.box.white,
            color: theme.palette.text.primary,
            border: `1px solid ${theme.palette.button.pure_red}`,
            borderRadius: '4px',
            padding: '2px 8px',
            textTransform: 'capitalize',
            fontFamily: theme.typography.fontFamily,
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '16px',
            '&:hover': {
              backgroundColor: theme.palette.box.white,
              color: theme.palette.text.primary,
              border: `1px solid ${theme.palette.button.pure_red}`,
            },
          })}
        >
          Retry
        </Button>
      </Stack>
    </Box>
  );
};

export default SharedWithErrorState;
